import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/runner/work/vitiquest-site/vitiquest-site/src/app/beginner-gen-ai/components/ProgramInteractive.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/runner/work/vitiquest-site/vitiquest-site/src/components/common/Header.tsx");
